import dev from "../config/config.dev.json"
import staging from "../config/config.staging.json"
import qa from "../config/config.qa.json"
import uw2 from "../config/config.production.uw2.json"
import ca1 from "../config/config.production.ca1.json"
import {useLocalStorageNew} from "./useLocalStorageNew";

export const useConfig = () => {
    let [setRunEnvironment, ] = useLocalStorageNew("ENGAGE_RUN_ENVIRONMENT", "");
    const run_environment = process.env.REACT_APP_RUN_ENVIRONMENT;

    if (!!run_environment) {
        setRunEnvironment(run_environment);
    }

    if (!!run_environment && run_environment === "PROD_UW2") {
        return uw2;
    } else if (!!run_environment && run_environment === "PROD_CA1") {
        return ca1;
    } else if (!!run_environment && run_environment === "STAGING_CA1") {
       return qa;
    } else if (!!run_environment && run_environment === "DEV") {
        return dev;
    } else {
        return staging;
    }
}